import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import ScrollToTop from '@app/components/LocalCommon/ScrollToTop/ScrollToTop';
import { SentryErrorBoundary } from '@app/components/UI/ErrorBoundary/SentryErrorBoundary';
import FindVetBlock from '@app/components/UI/FindVetBlock/FindVetBlock';
import Footer from '@app/components/UI/Footer/Footer';
import Header from '@app/components/UI/Header/Header';
import '@app/scss/style.scss';
import '@app/scss/components/chat.scss';

type PageProps = RouteComponentProps & { withScrollTop: boolean };

const Layout: React.FC<PageProps> = ({ children, withScrollTop = true, ...rest }) => {
	return (
		<div className="app-container">
			<SentryErrorBoundary>
				<Header />
				<div className="app-container-content">{children}</div>
				<FindVetBlock />
				<Footer />
				{withScrollTop && <ScrollToTop />}
			</SentryErrorBoundary>
		</div>
	);
};

export default withRouter(Layout) as any;
